import { render } from "./FormDraftView.vue?vue&type=template&id=cc2af018&scoped=true"
import script from "./FormDraftView.vue?vue&type=script&lang=js"
export * from "./FormDraftView.vue?vue&type=script&lang=js"

import "./FormDraftView.vue?vue&type=style&index=0&id=cc2af018&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc2af018"]])

export default __exports__